import { bl_fi_cash_document_file_helper_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class CashDocumentFileHelperContainer extends BaseContainerModel {
  bl_fi_cash_document_file_helper: bl_fi_cash_document_file_helper_RowClass = new bl_fi_cash_document_file_helper_RowClass();
}